import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { GOAL_STATUS } from 'resources/constants';

import SetGoal from './SetGoal';
import CurrentGoal from './CurrentGoal';
import CompletedGoal from './CompletedGoal';

const components = {
  [GOAL_STATUS.NONE]: SetGoal,
  [GOAL_STATUS.CURRENT]: CurrentGoal,
  [GOAL_STATUS.ACHIEVED]: CompletedGoal,
};

const deps = {
  currentGoal: state.challenge.info.computedCurrentGoal,
};

export function Goal({
  currentGoal,
}: typeof deps & ConnectedProps): React.ReactElement {
  const Component = components[currentGoal.status || GOAL_STATUS.NONE];

  return <Component />;
}

export default connect(deps, Goal);
